/*
 * Глобальный объект управления и инициализацией карты
 */
var MapObserver = {

    //Главная функция оповещающая подписчиков о загрузке гугл карт и дальнейшей инициализации
    init: function () {
        //console.log('Отработали');
        this._notifyObservers();
        this.loaded = true;
    },

    //Устанавливает налюдателя
    setObserver: function (object) {
        this.subscribers.push(object);
        return true;
    },

    //Создает и возвращает элемент карты
    newMap: function (element) {
        return new window.mainMap(element);
    },

    //Инициализирует наблюдателя
    _notifyObservers: function () {
        var self = this;
        this.subscribers.forEach(function (observerFunction){
            observerFunction(self);
        });

    },


    //Подписчики-наблюдатели
    subscribers: [],
    //Флаг загрузки карты
    loaded: false,
};